import { makeApiRequest } from 'actions/api';
import { GET_MEAL_SELLOUTS_V3 } from 'lib/constants/v3Actions';
import RequestService from 'services/RequestService';

export const getMealSellouts = menuSlug =>
  makeApiRequest({
    requestType: GET_MEAL_SELLOUTS_V3,
    method: RequestService.v3.getMealSellouts,
    params: { menuSlug },
  });
